import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cn } from '@/app/utils/cn';
interface DetailsContentRowProps {
  children: ReactNode;
  contentClassName?: string;
}
export const DetailsContentRow = t0 => {
  const $ = _c(5);
  const {
    children,
    contentClassName
  } = t0;
  let t1;
  if ($[0] !== contentClassName) {
    t1 = cn("relative lg:col-span-8 lg:col-start-3", contentClassName);
    $[0] = contentClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className="mt-6 lg:grid lg:grid-cols-12 lg:gap-6"><div className={t1}>{children}</div></div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};